export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_COLG_REPORT":
      return action.payload.data;
    default:
      return state;
  }
};
